export default __webpack_public_path__ + "static/media/Ruang-Kelas.119116ff.svg";